import {
  GraphQLID,
  GraphQLString,
  GraphQLObjectType,
  GraphQLNonNull,
  GraphQLBoolean
} from 'graphql'
import { authenticationAttemptRecord } from '../queries/authentication-attempt-record'
import { AuthenticationAttemptRecord } from './authentication-attempt-record'
import { Role, role } from './role'
import { LicenseBreakdownType, LicenseBreakdown } from './license-breakdown'
import { OrganizationType, organizationType } from './organization-type'

export interface Organization {
  id: string
  name: string
  type: OrganizationType
  role?: Role
  authenticationAttemptRecord?: AuthenticationAttemptRecord
  assessLicenseBreakdown: LicenseBreakdown
  protectLicenseBreakdown?: LicenseBreakdown
  restrictedEditRole?: boolean
}

export interface CurrentOrganization {
  id: string
  name: string
  assessLicenseBreakdown: LicenseBreakdown
}

export const organization = new GraphQLObjectType({
  name: 'Organization',
  fields: () => ({
    id: {
      description: 'The unique ID for an organization',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'Human readable name for an organization',
      type: new GraphQLNonNull(GraphQLString)
    },
    type: {
      description:
        'The type of organization, which indicates accessibility of various features',
      type: new GraphQLNonNull(organizationType)
    },
    role: {
      description: "The current user's most permissive role",
      type: role
    },
    authenticationAttemptRecord,
    assessLicenseBreakdown: {
      description: 'The breakdown of assess licenses',
      type: new GraphQLNonNull(LicenseBreakdownType)
    },
    protectLicenseBreakdown: {
      description: 'The breakdown of protect licenses',
      type: LicenseBreakdownType
    },
    restrictedEditRole: {
      description: 'Whether or not the organization has a restricted edit role',
      type: new GraphQLNonNull(GraphQLBoolean)
    }
  })
})

export const currentOrganization = new GraphQLObjectType({
  name: 'CurrentOrganization',
  fields: () => ({
    id: {
      description: 'The unique ID for an organization',
      type: new GraphQLNonNull(GraphQLID)
    },
    name: {
      description: 'Human readable name for an organization',
      type: new GraphQLNonNull(GraphQLString)
    },
    assessLicenseBreakdown: {
      description: 'The breakdown of assess licenses',
      type: new GraphQLNonNull(LicenseBreakdownType)
    }
  })
})
